import { Search } from "lucide-react";
import { useState } from "react";

interface CatalogFiltersProps {
  onChange: (params: { q?: string; showDeleted?: boolean }) => void;
}

const CatalogFilters = ({ onChange }: CatalogFiltersProps) => {
  const [q, setQ] = useState("");
  const [showDeleted, _setShowDeleted] = useState(false);

  return (
    <div className="flex flex-col sm:flex-row gap-2">
      <div className="mt-4 relative max-w-[280px]">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-brand-muted" />
        <input
          value={q}
          onChange={(e) => {
            setQ(e.target.value);
            onChange({ q: e.target.value, showDeleted });
          }}
          placeholder="Buscar..."
          className="w-[280px] px-3 py-2 border rounded-lg pl-9"
        />
      </div>
      {/* <div className="inline-flex items-center gap-2 text-sm text-gray-700 sm:mt-4">
        <select
          className="border text-sm rounded-lg px-3 py-2 min-w-[200px]"
          onChange={(e) => {
            const isDeleted = e.target.value === "eliminado";
            setShowDeleted(isDeleted);
            onChange({ q, showDeleted: isDeleted });
          }}
        >
          <option value="">Seleccionar estatus</option>
          <option value="activo">Activo</option>
          <option value="eliminado">Eliminado</option>
        </select>
      </div> */}
    </div>
  );
};

export default CatalogFilters;
